<template>
  <div class="calico-navbar-menu-view">
    <h2>Global Navigation Component</h2>
    <CalicoGlobalNavigation />
  </div>
</template>

<script>
import CalicoGlobalNavigation from "@/components/pattern/globalNavigation/index.vue";

export default {
  name: "GlobalNavigationView",
  components: {
    CalicoGlobalNavigation,
  },
  methods: {
    handleClick() {
      alert("Log out clicked");
    },
  }
};
</script>

<style scoped lang="scss">
.calico-navbar-menu-view {
  padding: $space-medium;
  position: relative;
}
</style>